import styles from './ApplePayButton.module.scss';

import React from 'react';
import clsx from 'clsx';

import { useInvoiceSummary } from 'routes/Checkout/context/InvoiceSummary';
import { useMerchant } from 'hooks/context/merchant';
import { useSubmitOrder } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';

import { useApplePay } from './ApplePay';
import { useGiftCardCart } from 'hooks/context/giftCardCart';

const APPLE_PAY_PAYMENT_METHOD = 'APPLE_PAY';

export const ApplePayButton: React.FC = () => {
  const { isApplePayEnabled } = useApplePay();
  const { itemCount } = useGiftCardCart();
  const { invoiceSummary } = useInvoiceSummary();
  const { merchant } = useMerchant();
  const { submitWithApplePay } = useSubmitOrder();

  const isApplePayEnabledForMerchant = merchant?.paymentMethods.includes(APPLE_PAY_PAYMENT_METHOD);

  if (!isApplePayEnabledForMerchant || !isApplePayEnabled || !invoiceSummary || itemCount > 0) return null;

  return (
    <div>
      <button
        aria-label="apple-pay"
        data-testid="APPLE_PAY"
        type="button"
        className={clsx(styles.applePayButton, styles.applePayButtonBlack, styles.payButton)}
        onClick={submitWithApplePay}
      />
    </div>
  );
};
